import React from 'react'
import Link, { LINK_THEMES } from 'components/Link'
import ResponsiveImage from 'components/ResponsiveImage'
import PoorText from 'components/PoorText'
import ReadMore from 'components/ReadMore'
import SimpleTagList from 'components/SimpleTagList'
import PropTypes from 'prop-types'
import cn from 'classnames'

const ArticleItem = ({
    link,
    date,
    dateFormatted,
    image,
    tags,
    introHtml,
    contactPersonLabel,
    contactPerson,
    publishedLabel,
    readMoreLabel,
    readLessLabel
}) => {
    const renderTopInfo = (forMobile = false) => {
        return (
            <div className={cn('article-list-item__top-info', {
                'article-list-item__top-info_mobile': forMobile
            })}>
                <div className='article-list-item__heading'>
                    <Link
                        {...link}
                        className='article-list-item__heading-link'
                    />
                </div>
                {date && <time className='article-list-item__date' dateTime={date}><span className='hidden-desktop'>{publishedLabel}: </span>{dateFormatted}</time>}
                <SimpleTagList items={tags} className='article-list-item__tags' />
            </div>
        )
    }

    return (
        <div className='article-list-item'>
            <div className='article-list-item__image'>
                <a 
                    href={link.url} 
                    className='article-list-item__image-link' 
                    target={link.openInNewTab ? '_blank' : null}
                    rel={link.openInNewTab ? 'noopener noreferrer' : null}  
                >
                    <ResponsiveImage 
                        {...image} 
                        fluid={true}
                        className="responsive-image_size_article-list-item" 
                    />
                </a>
            </div>
            {renderTopInfo(true)}
            <div className='article-list-item__content'>
                {renderTopInfo()}
                {
                    (introHtml || contactPerson) && (
                        <div className='article-list-item__details'>
                            {introHtml && (
                                <ReadMore 
                                    className='article-list-item__intro'
                                    readMoreText={readMoreLabel}
                                    readLessText={readLessLabel}
                                    destroyOnMobile={true}
                                >
                                    <PoorText text={introHtml} className='poor-text_in-article-list-item' />
                                </ReadMore>
                            )}
                            {contactPerson && (
                                <div className='article-list-item__contact-person'>
                                    <span>{contactPersonLabel}: <a className='article-list-item__link' href={`mailto:${contactPerson.email}`}>{contactPerson.name}</a> , {contactPerson.jobTitle}</span>
                                </div>
                            )}
                        </div>
                    )
                }
                
            </div>
        </div>
    )
}

ArticleItem.propTypes = {
    id: PropTypes.number,
    link: PropTypes.exact(Link.propTypes),
    date: PropTypes.string,
    dateFormatted: PropTypes.string,
    image: PropTypes.exact(ResponsiveImage.propTypes),
    tags: PropTypes.arrayOf(PropTypes.string),
    introHtml: PropTypes.string,
    contactPersonLabel: PropTypes.string,
    publishedLabel: PropTypes.string,
    readMoreLabel: PropTypes.string,
    readLessLabel: PropTypes.string,
    contactPerson: PropTypes.shape({
        name: PropTypes.string,
        email: PropTypes.string,
        jobTitle: PropTypes.string
    })
}

ArticleItem.propTypesMeta = {
    contactPersonLabel: 'exclude',
    publishedLabel: 'exclude',
    readMoreLabel: 'exclude',
    readLessLabel: 'exclude'
}

export default ArticleItem
